import { render, staticRenderFns } from "./table-new.vue?vue&type=template&id=52ad30ca&scoped=true&"
import script from "./table-new.vue?vue&type=script&lang=js&"
export * from "./table-new.vue?vue&type=script&lang=js&"
import style0 from "./table-new.vue?vue&type=style&index=0&id=52ad30ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad30ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ad30ca')) {
      api.createRecord('52ad30ca', component.options)
    } else {
      api.reload('52ad30ca', component.options)
    }
    module.hot.accept("./table-new.vue?vue&type=template&id=52ad30ca&scoped=true&", function () {
      api.rerender('52ad30ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/finance/components/account-history-table/table-new.vue"
export default component.exports